import { navigate } from 'gatsby'
import { useEffect } from 'react'
import { getUserWallet } from '../adapters/user'
import { EnvConfig } from '../config/EnvConfig'
import {
  CASHBACK_CASHOUT_COMPLETED_EVENT,
  CASINO_PROVIDERS,
  IN_GAME_DEPOSIT_OPEN_DEPOSIT_DRAWER_EVENT,
  oryxGameProvidersSupportingCashierEvent,
} from '../utils/constants'
const { ORYX, PLAYTECH, EVOLUTION } = CASINO_PROVIDERS
const TRANSACTION_COMPLETED_EVENT = 'transactionCompleted'
const PLAYTECH_DEPOSIT_PAGES = ['cashier', 'deposit', 'bank']

export const useGameEventHandling = (
  casinoProvider,
  providerSlug,
  isCasinoGameWalletPullingEnabled,
  casinoBackLink
) => {
  
  const shouldRefreshGameBalance = ({ data: eventData }) => {
    return (
      eventData === TRANSACTION_COMPLETED_EVENT ||
      eventData === CASHBACK_CASHOUT_COMPLETED_EVENT
    )
  }

  useEffect(() => {
    let incomingEventHandler
    let outgoingEventHandler

    switch (casinoProvider) {
      case ORYX:
        incomingEventHandler = handleIncomingOryxEvents
        outgoingEventHandler = handleOutgoingOryxEvents
        break
      case PLAYTECH:
        incomingEventHandler = handleIncomingPlaytechEvents
        outgoingEventHandler = handleOutgoingPlaytechEvents
        break
      case EVOLUTION:
        incomingEventHandler = handleIncomingEvolutionEvents
        outgoingEventHandler = handleOutgoingEvolutionEvents
        break
      default:
        incomingEventHandler = null
        outgoingEventHandler = null
    }
    if (!incomingEventHandler && !outgoingEventHandler) return

    window.addEventListener('message', incomingEventHandler)
    window.addEventListener('message', outgoingEventHandler)

    return () => {
      window.removeEventListener('message', incomingEventHandler)
      window.removeEventListener('message', outgoingEventHandler)
    }
  }, [casinoProvider, isCasinoGameWalletPullingEnabled])

  const sendOpenDepositDrawerEvent = () => {
    const openDepositDrawerEvent = new CustomEvent(
      IN_GAME_DEPOSIT_OPEN_DEPOSIT_DRAWER_EVENT
    )
    document.body.dispatchEvent(openDepositDrawerEvent)
  }

  const handleIncomingEvolutionEvents = (event) => {
    if (event?.data?.event === 'EVO:APPLICATION_READY') {
      event.source.postMessage(
        {
          command: 'EVO:EVENT_SUBSCRIBE',
          event: 'EVO:SHOW_DEPOSIT',
        },
        '*'
      )
    }
    
    if (event?.data?.event === 'EVO:SHOW_DEPOSIT') {
      sendOpenDepositDrawerEvent()
    }
  }

  const handleIncomingPlaytechEvents = (event) => {
    if (typeof event.data !== 'string') return

    const parsedEventData = JSON.parse(event.data)
    const iframe = document.getElementById('game')
    if (parsedEventData._type === 'ucip.basic.g2wCloseGameFrameCommand') {
      navigate('/')
    }

    if (parsedEventData._type === 'ucip.openpage.g2wOpenPageCommand') {
      if (!PLAYTECH_DEPOSIT_PAGES.includes(parsedEventData.pageID)) return
      sendOpenDepositDrawerEvent()
    }

    if (parsedEventData._type === 'ucip.basic.g2wInitializationRequest') {
      const response = JSON.stringify({
        _type: 'ucip.basic.w2gInitializationResponse',
        version: '1.0.7',
        features: [
          ['openpage', { delegatePages: PLAYTECH_DEPOSIT_PAGES }],
          'balancerefresh',
        ],
      })
      iframe.contentWindow.postMessage(response, '*')
    }
  }

  const handleIncomingOryxEvents = (event) => {
    if (
      event?.data?.type === 'Window.Redirect' &&
      event?.data?.url === `${EnvConfig.SITE_URL}/`
    ) {
      navigate('/')
      return
    }

    if (event?.data?.rgMessage === 'gprg_Listening') {
      event.source.postMessage({ rgMessage: 'oprg_Ready' }, '*')
    }

    if (
      event?.data?.rgMessage === 'gprg_UserAction' &&
      event?.data?.payload?.action === EnvConfig.SITE_URL
    ) {
      navigate('/')
    }

    if (
      event?.data?.wpgaction === 'gameSpinEnd.parent' &&
      isCasinoGameWalletPullingEnabled
    ) {
      getUserWallet()
    }

    if (
      event?.data?.wpgaction === 'cashier' &&
      oryxGameProvidersSupportingCashierEvent?.includes(providerSlug)
    ) {
      sendOpenDepositDrawerEvent()
    }

    if (event?.data?.wpgaction === 'close') {
      navigate(casinoBackLink)
    }
  }

  const handleOutgoingOryxEvents = (event) => {
    const iframe = document.getElementById('game')

    if (!iframe?.contentWindow) return
    if (shouldRefreshGameBalance(event)) {
      iframe.contentWindow.postMessage({ wpgaction: 'updateBalance' }, '*')
    }
  }

  const handleOutgoingPlaytechEvents = (event) => {
    const iframe = document.getElementById('game')

    if (!iframe?.contentWindow) return
    if (shouldRefreshGameBalance(event)) {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          _type: 'ucip.balancerefresh.w2gRefreshBalanceCommand',
        }),
        '*'
      )
    }
  }

  const handleOutgoingEvolutionEvents = (event) => {
    const iframe = document.getElementById('game')

    if (!iframe?.contentWindow) return
    if (shouldRefreshGameBalance(event)) {
      iframe.contentWindow.postMessage(
        {
          command: 'EVO:REFRESH_BALANCE',
        },
        '*'
      )
    }
  }
}
